import { useQuery } from 'react-query';
import { fetchPodTypes } from 'react-scale/components/ExpertManagement/ExpertManagementPage/api';
import {
  setPodTypesSelector,
  useStatContextStore,
} from 'react-scale/components/ExpertManagement/stores/statContext.store';
import { shallow } from 'zustand/shallow';

export const useFetchPodTypes = () => {
  const setPodTypes = useStatContextStore(setPodTypesSelector, shallow);
  return useQuery([`fetchPodTypes`], () => fetchPodTypes(), {
    onSuccess: data => {
      setPodTypes(data.podTypes);
    },
    staleTime: 24 * 60 * 60 * 1000,
  });
};
